<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div style="height:520px">
          <div v-if="integrationWizardIndex >= 1">
            <h3 v-if="integrationWizardIndex == 1" class="cnct-aws-header">Enable the Google APIs</h3>
            <h3 v-if="integrationWizardIndex == 2" class="cnct-aws-header">Connect GCP Account to Confluera</h3>          
            <h3 v-if="integrationWizardIndex == 3" class="cnct-aws-header">Success!</h3>
            <h3 v-if="integrationWizardIndex == 4" class="cnct-aws-header">Error!</h3>
            
            <el-steps
              v-if="integrationWizardIndex <= 3"
              class="el-step-fixes"
              :active="integrationWizardIndex"
              :finish-status="apiCall.error? 'error': 'success'"
            >
              <el-step></el-step>
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>

          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
          >
            <el-carousel-item :key="1">
              <span class="cnct-aws-header" style="margin-bottom: 22px">Connect to Google Cloud Account</span>
              <p class="top-header">
                This wizard walks you through the simple steps to connect Confluera CxDR to your Google Cloud account.
                If you have multiple Google Cloud accounts, simply run this wizard to configure each account.
              </p>

              <el-row type="flex" :gutter="24" style="margin: -32px 0px 0px;">
                <el-col :span="4" class="integration-logo-container">
                  <el-card shadow="hover" class="integration-logo-card">
                    <span class="display-block" style="margin-top: 14px; margin-left: 6px">
                      <img
                        style="margin-left: 10px; width:100px; height: 100px;"
                        src="/static/images/logos/gcp_logo_color.svg"
                      />
                    </span>
                  </el-card>
                </el-col>
                <el-col :span="20" class="connect-aws">
                  <el-row>
                    <el-row>
                      <el-col :span="23"><span class="bold">Step 1</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        Log into GCP console to enable the Google APIs.
                      </el-col>
                      <el-col :span="23">
                        Create a GCP Service Account
                      </el-col>
                      <el-col :span="23">
                        Create a Key and download as JSON file
                      </el-col>
                      <el-col>
                        <span class="text-btn" @click="loadDocumentation('page-cloud-gcp')"> Learn More </span>
                      </el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23"><span class="bold">Step 2</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">Upload the JSON to Confluera</el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23"><span class="bold">Step 3</span></el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">Verify and submit</el-col>
                    </el-row>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item :key="2">
              <p class="mb-15" style="height: 4em">
                Prerequisites to connecting GCP Account to Confluera
              </p>
              <el-row type="flex" style="margin-top: -32px">
                <el-col :span="24" class="connect-aws">
                  <el-row class="mb-15">
                    <el-row>
                      <el-col :span="24">
                        <span>
                          <span class="bold">Enable Google APIs under your existing GCP account</span><br />
                          Log in to Google Cloud Platform using your existing GCP account. This account must have access
                          to all the GCP projects that contain VMs that you want to protect with Confluera.
                          <span class="text-btn" @click="loadDocumentation('page-cloud-gcp')"> Learn More </span>
                        </span>
                      </el-col>
                    </el-row>
                  </el-row>
                  <el-row class="mb-15">
                    <el-row>
                      <el-col :span="24">
                        <span>
                          <span class="bold">Create Google Cloud Service Account</span><br />
                          Log in to Google Cloud Platform using your existing GCP account. Select
                          <span class="bold"> IAM & admin > Service accounts </span>
                          <span class="text-btn" @click="loadDocumentation('page-cloud-gcp')"> Learn More </span>
                        </span>
                      </el-col>
                    </el-row>
                  </el-row>
                  <el-row class="mb-15">
                    <el-row>
                      <el-col :span="24">
                        <span>
                          <span class="bold">Download a JSON file</span><br />
                          The key is generated and placed in a JSON file. Save the key (JSON file) to a safe place. If
                          you need to move or distribute the file, make sure you do so using secure methods.
                          <span class="text-btn" @click="loadDocumentation('page-cloud-gcp')"> Learn More </span>
                        </span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item :key="3">
              <div class="header-carousal-2">
                Upload your GCP service account settings to setup the Google Cloud account connection
              </div>
              <div class="box flex">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-row :type="'flex'" :gutter="8" class="mt-20">
                    <el-col>
                      <el-row :gutter="20">
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Account Nickname"></el-form-item>

                          <el-input
                            v-model="integrationWizardData.nickName"
                            placeholder="Enter a nickname for your connection"
                            @keydown.native.space.prevent
                          ></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Scan Frequency"></el-form-item>
                          <el-select
                            style="width: 100%"
                            v-model="integrationWizardData.scanFrequency"
                            placeholder="Select Frequency"
                          >
                            <el-option
                              v-for="item in [
                                { label: '1 Minute', value: 60000 },
                                { label: '3 Minute', value: 60000 * 3 },
                                { label: '5 Minute', value: 60000 * 5 }
                              ]"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Upload Service Account Key"></el-form-item>

                          <div class="image-upload">
                            <label for="file-input">
                              <i class="el-icon-upload"></i>
                              <div class="el-upload__text">Browse to choose a file</div>
                              <input
                                id="gcp_account_file"
                                type="file"
                                accept=".json"
                                ref="gcpAccountFile"
                                @change="handleFileUpload($event)"
                              />
                            </label>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4">             
              <div>
                <img src="/static/images/gcpSuccess.svg" alt="SUCCESS" />
              </div>
              <div class="initiated_message">
                <span>You've added your GCP Account assets. Now you'll be</span><br>
                <span>able to observe them in one secure environmemt.</span>
              </div>
              <div class="mt-25">
                <el-button
                type="primary"
                size="medium"
                style="background-color: #1A90FA;"
                @click="gotoDiscoveryIntegrationWorkflow"
               >Cloud Accounts</el-button>
              </div>
              <div class="initiated_message">
                <span>You can now add <strong>Kubernetes</strong> for your GCP Account.</span>
                <router-link class="display-block" style="width: 14%" :to="{ name: 'installation', query: { os: 'kubernetes' } }">
                  <a>Set up Kubernetes</a>
                </router-link><br>
                <span>View <strong>Discovered Instances</strong> for your GCP Account.</span>
                <router-link class="display-block" style="width: 16%" :to="{ name: 'hosts', query: { hostfilter: 'gcp' } }">
                  <a>Discovered instances</a>
                </router-link>
              </div> 
            </el-carousel-item>
            <el-carousel-item :key="5" class="initiated error mt-20">              
              <div>
                <img src="/static/images/gcpError.svg" alt="ERROR" />
              </div>
              <div class="initiated_message mt-60">
                <span><b>Could Not Connect</b></span><br>
                <span>We could not connect to your Google cloud account.</span><br>
                <span>Troubleshoot to fix your configuration.</span><br><br>
                <span>invalid-integration-config: the integration configuration was invalid.</span>
              </div>
              <div class="mt-89">
                <el-button
                type="primary"
                size="medium"
                style="background-color: #1A90FA;"
                @click="loadDocumentation('page-cloud-gcp')"
               >Troubleshoot</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex">
            <span              
              v-if="[1, 2, 4].includes(integrationWizardIndex)"
              class="text-underline cursor-pointer back-button go-back-button"
              @click="backIntegrationStep"
              >Back
            </span>
            <el-button
              class="start-button"
              v-if="integrationWizardIndex < 1"
              size="medium"
              round
              @click="nextIntegrationStep"
            >
              Start
            </el-button>
            <el-button
              class="submit-button"
              v-else-if="integrationWizardIndex == 2"
              size="medium"
              round
              @click="updateIntegrationSettings"
            >
              Submit
            </el-button>           
            <el-button
              class="verify-button"
              v-else-if="integrationWizardIndex == 1"
              size="medium"
              round
              @click="nextIntegrationStep"
            >
              GCP Account
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import { GCP_CONNECTION_SETTINGS_CREATE_REQUEST } from '@/store/modules/integrations/gcp-connection-settings.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'GcpIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationLastStep: 4,
      integrationWizardSteps: [
        'Go to IAM console->Roles',
        'Create new role',
        'Select "Another AWS Account"',
        'Put Account# of Confluera <347227527012>',
        'Put External ID# of Confluera <a345aj-sxsax-1jwdewdw>',
        'Select and attach two policies: AWSConfigRole policy and AWSConfigUserAccess policy',
        'Create role (e.g. ConfigAccessRole)'
      ],
      apiDispatchState: GCP_CONNECTION_SETTINGS_CREATE_REQUEST,
      apiCall: {
        outbound: false,
        error: false,
        errMsg: ''
      },
      fileUploadError: {
        error: false,
        message: ''
      },
      fileUploadFlag: false
    }
  },
  methods: {
    validateNickName () {
      let isValidNickName = true
      let errMsg;

      if (!this.integrationWizardData.nickName) {
        isValidNickName = false;
        errMsg = "Please enter a valid nickname"
      } else if (_.has(this.cloudIntegrationAccounts, 'models') && this.cloudIntegrationAccounts.models.length) {
        for (let acct of this.cloudIntegrationAccounts.models) {
          if (this.integrationWizardData.nickName.toLowerCase() === acct.nickName.toLowerCase()) {
            errMsg = "Nickname already exists"
            isValidNickName = false
            break
          }
        }
      }
      
      if (!this.fileUploadFlag) {
        this.$message({
          type: 'error',
          message: 'Please verify Service Account Key is properly uploaded.'
        })
      } else if (!this.integrationWizardData.project_id) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Project ID is properly uploaded.'
        })
      } else if (!this.integrationWizardData.private_key_id) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Private Key ID is properly uploaded.'
        })
      } else if (!this.integrationWizardData.client_email) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Client Email is properly uploaded.'
        })
      } else if (!this.integrationWizardData.client_id) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Client ID is properly uploaded.'
        })
      } else if (!this.integrationWizardData.token_uri) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Token URI is properly uploaded.'
        })
      } else if (!this.integrationWizardData.auth_provider_x509_cert_url) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Auth Provider x509 Cert URL is properly uploaded.'
        })
      } else if (!this.integrationWizardData.client_x509_cert_url) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP Client x509 Cert URL is properly uploaded.'
        })
      } else if (!this.integrationWizardData.type) {
        this.$message({
          type: 'error',
          message: 'Please verify GCP type is properly uploaded.'
        })
      } else if (isValidNickName) {
        this.nextIntegrationStep()
      } else {
        this.$message({
          type: 'error',
          message: errMsg
        })
      }
    },
    handleFileUpload (event) {
      let file = this.$refs.gcpAccountFile.files[0]
      // parse only if a file is selected
      if (file) {
        this.fileUploadError.error = false

        let reader = new FileReader()
        reader.readAsText(file, 'UTF-8')
        reader.onload = evt => {
          if (file.type === 'application/json') {
            try {
              let jsonContent = JSON.parse(evt.target.result)
              _.extend(this.integrationWizardData, jsonContent)
              this.fileUploadFlag= true
              this.$message({
                type: 'success',
                message: 'File successfully uploaded. Click Verify to confirm the settings.'
              })
            } catch (error) {
              this.fileUploadError.error = true
              this.fileUploadError.message = 'Error parsing JSON file'
            }
          }
        }
        reader.onerror = evt => {
          console.error(evt)
        }
      }
      // clear target value to accpet same file again
      event.target.value = ''
    }
  },
  created () {},
  computed: {
    ...mapGetters(['cloudIntegrationAccounts'])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.integration-settings {
  overflow: unset;
}

.initiated {
  h4 {
    margin-bottom: 40px;
  }

  p {
    text-align: center;
    width: 60%;
    margin: auto;
    display: block;
  }

  >>> .el-button {
    margin: auto;
  }

  >>> .el-icon-loading,
  .material-icons {
    font-size: 2em;
  }

  .center-text.error-icon {
    margin: auto;
    font-size: 2em;
  }
}

>>> .el-carousel--horizontal {
  overflow-x: hidden;
  width: 110%;
}

>>> .el-step__head.is-success {
  color: #1a90fa;
}

>>> .el-step__head {
  fill: #1a90fa;
  border-color: #1a90fa;
}

>>> .el-step__line {
  background-color: #1a90fa;
}

>>> .el-step__icon-inner {
  color: #1a90fa;
}

.el-form-item {
  margin-bottom: 0px;
}
.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.error-message {
  width: 60%;
  margin: 30px auto;

  p {
    width: 100%;
  }
}

.top-header {
  height: 94px;
  width: 834px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0.17px;
  line-height: 22px;
}

.top-header-title {
  font-weight: 500px;
  font-size: 24px;
  margin-bottom: 22px;
}
.aws-content {
  height: 308px;
  width: 616px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.start-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  margin-left: 75%;
  text-align: center;
}

.verify-button,
.submit-button {
  height: 36px;
  width: auto;
  min-width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  margin-bottom:5%;
  text-align: center;
}

.go-back-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-left: 60%;
  text-align: center;
  border: 1px solid #767676;
  text-decoration: none;
}
.conf-block {
  display: inline-block;
  width: 34.86%;
  height: 27.34%;
  line-height: 20px;
  letter-spacing: 0.09px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 50px;
}

.header-carousal-2 {
  height: 66px;
  width: 575px;
  color: #454b60;
  /* font-family: Montserrat; */
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 22px;
}

.carousal-3-content {
  margin-bottom: 20px;
  font-size: 14px;
}

.integration-settings {
  .el-steps {
    width: 50%;
    min-width: 500px;
    padding: 20px 10px 25px 10px;
    margin: 0 0 20px 0;
    border-bottom: solid 0px #f0f0f0;
  }

  >>> .el-carousel {
    margin: 10px 0 30px 0;

    .el-carousel__container {
      height: 440px;
    }
  }
}

.cnct-aws-header {
  margin-bottom: 20px;
  margin-top: 10px;
  font-weight: 500px;
  font-size: 24px;
}

.el-step-fixes {
  width: 20%;
  padding-left: 0px;
  border: none;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

.connect-aws {
  margin-left: 12px;
  width: 65%;
  height: 198px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.image-upload {
  width: 428px;
  height: 170px;
  border: 2px dotted #f0f0f0;

  .icon-file-upload {
    background: var(--gray-500);
  }

  #gcp_account_file {
    z-index: 99;
    opacity: 0;
    position: relative;
    cursor: pointer;
    left: 0px;
    top: -100px;
    width: 428px;
    height: 170px;
    border: 2px dotted #f0f0f0;
  }
}

.el-icon-upload {
  font-size: 3em;
  margin-left: 200px;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 10%;
}

.el-upload__text {
  text-align: center;
}

.initiated_message{
  color: #454B60;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
  text-align: left;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/GcpIntegrationWorkflow.vue